import React from "react";
import Helmet from "react-helmet";

class PaiaManual extends React.Component {

    componentDidUpdate() {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }

    render() {
        const dtm_deviceCheck = /Mobile/i.test(navigator.userAgent) ? "Mobile" : "Desktop";
        const dataLayer = {
            "formName": "",
            "formStatus": "",
            "formisSubmitted": false,
            "deviceType": dtm_deviceCheck,
            "siteBusinessUnit": "Tutuwa",
            "siteErrorCode": "",
            "siteLanguage": "English",
            "siteCountry": "South Africa",
            "websiteName": "Tutuwa Foundation",
            "websiteNameCode": "TT",
            "pageCategory": "Legal",
            "pageName": "Paia Manual",
            "pageSubSection1": "Legal",
            "pageSubSection2": "",
            "pageSubSection3": "",
            "pageSubSection4": ""
        };
        return (

            <div className="paia-manual-page">

                <Helmet>
                    <title>The Standard Bank Tutuwa Community Foundation: Paia Manual </title>
                    <meta name="title" content="The Standard Bank Tutuwa Community Foundation: Paia Manual " />
                    <meta name="description" content="We aim to help young South Africans reach their full potential and make an active contribution to their community." />
                    <meta name="keywords" content="Standard bank; tutuwa foundation; South African youth; investing in South Africa’s youth; social impact initiatives; economic development; investing in social impact bonds; impact investing; thought leadership; economic growth and development; industrial development; department of trade, industry and competition; youth empowerment; black economic empowerment" />
                    <meta name="robots" content="index, follow" />
                    <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
                    <meta name="language" content="English" />
                    <script type="text/javascript" language="javascript">{`
					var dataLayer = ${JSON.stringify(dataLayer)};
				`}</script>
                    {/* <script src="https://assets.adobedtm.com/45b28ee1a4af/201532f76abd/launch-e88652abdf04.min.js" async></script> */}
                </Helmet>


                <div className="content-wrapper">

                    <div className="content">

                        <h2>PAIA Manual</h2>

                        <p>In accordance with the Promotion of Access to Information Act, 2000 (PAIA), the Standard Bank Tutuwa Community Foundation NPC (the Foundation) has compiled a PAIA Manual to promote transparency, accountability and access to information. The manual provides details of the records held by the Foundation and outlines the process that individuals may follow to request access to such information.</p>

                        <h4>To view our PAIA Manual, please click the link below:</h4>

                        <p><a href="assets/downloads/PAIA_Manual_Tutuwa_Foundation_Approved.pdf" target="_blank" rel="noopener noreferrer">PAIA Manual</a></p>

                        <h4>To assist data subjects with information requests, we have made the following documents available:</h4>

                            <p>
                            <ul>
                                <li><a href="assets/downloads/PAIA FORM 2-REQUEST FOR ACCESS TO RECORD.pdf" target="_blank" rel="noopener noreferrer">PAIA Form 2 </a> –Request for access to a record to be completed by a requester seeking access to a record of the Foundation.</li>
                                <li><a href="assets/downloads/PAIA FORM 5-COMPLAINT TO THE INFORMATION REGULATOR.pdf" target="_blank" rel="noopener noreferrer">PAIA Form 5 </a>:– Complaint to the Information Regulator to be completed by a requester or third party who wishes to lodge a complaint with the Regulator against a decision of the Foundation, within 180 days of the decision.</li>
                                <li><a href="assets/downloads/POPIA FORM 1-OBJECTION TO THE PROCESSING OF PERSONAL INFORMATION.pdf" target="_blank" rel="noopener noreferrer">POPIA Form 1</a> – Objection to the processing of personal information: to be completed by a data subject who objects to the processing of their personal information in terms of section 11(3) of POPIA.</li>
                                <li><a href="assets/downloads/PAIA FORM 2-REQUEST FOR ACCESS TO RECORD.pdf" target="_blank" rel="noopener noreferrer">POPIA Form 2</a> – Request for correction or deletion of personal information: to be completed by a data subject in terms of section 24 of POPIA.</li>
                            </ul>
                            </p>
                        <p>For any queries relating to the PAIA Manual or requests for access to information, please contact our Information Officer at <a href="mailto:Tracey.Henry@standardbank.co.za">Tracey.Henry@standardbank.co.za</a> or Deputy Information Officer at <a href="mailto:Riekie.vanTonder@standardbank.co.za">Riekie.vanTonder@standardbank.co.za</a>.</p>
                        <p>If you are a third-party service provider or Partner, we may collect personal information about you as a data subject in order to ensure that the business relationship and matters relating to the agreement between you and us can be fulfilled. You warrant that, if you provide us with any personal information about other persons, such as your directors for the purpose of screening, you are authorised to share their personal information with us for purposes set out in this statement.</p>

                        <p>We are committed to ensuring compliance with applicable legislation and facilitating lawful access to information while protecting confidential, proprietary and personal information where required by law.</p>





                        {/* <p>After engaging us and should your queries still not be addressed to your satisfaction, you have the right to lodge a formal complaint with the SA Information Regulator using Form 5, available at <a href="www.inforegulator.org.za">www.inforegulator.org.za</a>.</p> */}

                    </div>


                </div>


            </div>

        );

    }

}

export default PaiaManual;
